import uabsRotas from './uabs/UabsRotas'
import fornecedorRotas from './fornecedores/FornecedorRotas'
import gestoresRotas from './gestores/GestoresRotas'
import gerentesRotas from './gerentes/GerentesRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import adminRotas from './admin/AdminRotas'

export default {
    path: 'credenciados',
    name: 'Credenciados',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        uabsRotas,
        fornecedorRotas,
        gestoresRotas,
        gerentesRotas,
        apoiosRotas,
        adminRotas
    ]
}
